import { useEffect, useState } from "react";

export const useCurrentUserImage = () => {
  const [image, setImage] = useState<string | null>(null);

  useEffect(() => {
    // Use your API route instead of direct Graph API access
    setImage(`/api/user-photo?t=${Date.now()}`);
  }, []);

  return image;
};